import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import T from 'i18n-react';
import LogoImage from '../../../images/icons/logo.png';
import { ServiceButton } from '../../core/Button';
import { LOGIN, SIGN_UP } from '../routing';
import { AppDialog } from '../../core/Dialog/AppDialog';
import { withSnackbar } from 'notistack';

const styles = (theme) => ({
  logo: {
    width: 80,
    height: 80,
    margin: 10,
  },
  paper: {
    width: 'auto',
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(1),
    },
  },
  content: {
    textAlign: 'center',

    '& p': {
      marginBottom: theme.spacing(1.5),
    },

    margin: '0px 10px 20px',
    padding: '8px 8px',
    [theme.breakpoints.up('sm')]: {
      padding: '8px 24px',
    },
  },
  containerButtons: {
    display: 'flex',
    justifyContent: 'center',
    borderTop: 'solid 1px rgba(0,0,0,0.20)',

    margin: '0px 10px',
    padding: '10px 0px',
    [theme.breakpoints.up('sm')]: {
      padding: '15px 100px',
    },
  },
  button: {
    fontWeight: 'bold',
    margin: '10px 6px',
    [theme.breakpoints.up('sm')]: {
      margin: 20,
    },
  },
});

class SignupDialog extends AppDialog {
  getDialogProps = () => ({ classes: { paper: this.props.classes.paper } });

  getDialogTitleProps = () => ({ style: { padding: 12 } });

  getDialogContentProps = () => ({ className: this.props.classes.content });

  dialogContentRenderer = () => {
    const { classes, contentNode } = this.props;

    return (
      <>
        <div>
          <img
            className={classes.logo}
            src={LogoImage}
            alt={T.translate('otetsutabi')}
          />
        </div>
        {contentNode}
      </>
    );
  };

  dialogActionsRenderer = () => {
    const { classes } = this.props;

    return (
      <div className={classes.containerButtons}>
        <ServiceButton
          className={classes.button}
          size="large"
          color="primary"
          variant="outlined"
          href={LOGIN}
        >
          {T.translate('login')}
        </ServiceButton>
        <ServiceButton
          className={classes.button}
          size="large"
          color="primary"
          variant="contained"
          href={SIGN_UP}
        >
          {T.translate('signup')}
        </ServiceButton>
      </div>
    );
  };
}

export default withSnackbar(withStyles(styles)(SignupDialog));
